import React, { useEffect } from 'react';
import * as nativeApi from 'utils/nativeApi';
import * as accountAPI from 'lib/api/account';
/** FCM 토큰 Setting  */
function useFcmToken(fcmToken, users) {
  /** FCM TOKEN 요청 (앱 푸쉬 알림 기능을 위한 토큰) */
  useEffect(() => {
    nativeApi.getFcmToken();
    nativeApi.getNotification();
    nativeApi.getAppInfo();
  }, []);

  useEffect(() => {
    if (fcmToken && users) {
      accountAPI.registerFcmToken(fcmToken);
    }
  }, [fcmToken, users]);
}
export default useFcmToken;
